import React from 'react';
import { Typography } from '../../typography';
import styles from './form-item.module.scss';
export const FormItem = ({ children, label, type = 'edit', noMargin = false, rowLayout = 'vertical', }) => {
    const rowRenderer = () => {
        let renderer = React.createElement(React.Fragment, null);
        if (type === 'edit') {
            renderer = (React.createElement(React.Fragment, null,
                children,
                rowLayout === 'horizontal' && (React.createElement("div", { className: styles.editRowSeperator }))));
        }
        else if (type === 'view') {
            renderer = (React.createElement("div", { className: styles.formItemContainer },
                React.createElement("div", { className: styles.formItemRow },
                    React.createElement("div", { className: styles.forRowWidthViewMode }, label ? (React.createElement(Typography, { variant: "p", className: styles.formRowLabel, noMargin: type === 'view'
                            ? noMargin
                            : false }, label)) : (React.createElement(React.Fragment, null))),
                    React.createElement("div", { className: styles.forRowWidthViewValue }, children))));
        }
        return renderer;
    };
    return React.createElement(React.Fragment, null, rowRenderer());
};
//# sourceMappingURL=form-item.js.map